import { render, staticRenderFns } from "./tblCalculationLabData.vue?vue&type=template&id=2d3360b4&scoped=true"
import script from "./tblCalculationLabData.vue?vue&type=script&lang=js"
export * from "./tblCalculationLabData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3360b4",
  null
  
)

export default component.exports